var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"}},[_c('el-radio',{attrs:{"label":"2"},model:{value:(_vm.flexBtn),callback:function ($$v) {_vm.flexBtn=$$v},expression:"flexBtn"}},[_vm._v(" 悬浮于页面底部 ")]),_c('el-radio',{attrs:{"label":"1"},model:{value:(_vm.flexBtn),callback:function ($$v) {_vm.flexBtn=$$v},expression:"flexBtn"}},[_vm._v(" 按顺序排列 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }